export function getUserIdentifier() {
    if (Office?.context?.mailbox?.userProfile) {
        const profile = Office.context.mailbox.userProfile;
        if (profile.emailAddress) return profile.emailAddress;
        if (profile.displayName) return profile.displayName;
    }

    if (typeof process !== "undefined" && process.env) {
        return process.env.USER || process.env.USERNAME || process.env.LOGNAME;
    }

    if (typeof navigator !== "undefined") {
        if (navigator.userAgent) return navigator.userAgent;
    }

    return "UnknownUser";
  }
